var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.collectionKind)?_c('div',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.collectionKind.get("name"))+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"lists"},_vm._l((_vm.currentCollections),function(collection,index){return _c('classic-item',{key:index,attrs:{"collection":collection}})}))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c93189e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CollectionKind.vue
// module id = 1611
// module chunks = 0